goog.provide("shadow.js.shim.module$src$svg$type$ad_format$youtube_bumper_svg$default");
shadow.js.shim.module$src$svg$type$ad_format$youtube_bumper_svg$default = shadow.js.shim.module$src$svg$type$ad_format$youtube_bumper_svg.default;
